export const formatAmount = (
  amount,
  currency = 'PLN',
  locale = 'pl-PL',
  options = { minimumFractionDigits: 2 }
) => {
  const formattedAmount = (+amount).toLocaleString(locale, options);
  return !currency ? formattedAmount : `${formattedAmount} ${currency}`;
}
